"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const Transaction_1 = require("../models/Transaction");
class TransactionService {
    constructor(cryptoService, transport, storageService, validator, ignoreAndBlockControlService, ignoreAndBlockFilterService, maxSignaturesNumber = 0) {
        this.onNewTransactionsCallbacks = [];
        this.transport = transport;
        this.storageService = storageService;
        this.validator = validator;
        this.cryptoService = cryptoService;
        this.ignoreAndBlockFilterService = ignoreAndBlockFilterService;
        this.ignoreAndBlockControlService = ignoreAndBlockControlService;
        this.maxSignaturesNumber = maxSignaturesNumber;
        this.transport.addOnIncomingTransactionsCallback((transactions) => __awaiter(this, void 0, void 0, function* () {
            yield this.handleIncomingTransactions(transactions);
        }));
    }
    createTransaction(creator, type, model) {
        return __awaiter(this, void 0, void 0, function* () {
            const hash = this.cryptoService.calculateTransactionHash(creator, type, model);
            const transaction = new Transaction_1.Transaction(creator, type, model, hash);
            yield this.validator.validateSpecific(yield this.getTransactions(), transaction);
            return transaction;
        });
    }
    getTransactions(removeIgnored = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const allTransactions = yield this.storageService.getTransactions();
            if (!removeIgnored) {
                return allTransactions;
            }
            return yield this.ignoreAndBlockFilterService.filterIgnored(allTransactions);
        });
    }
    signAndSend(sender, transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const signedTx = this.cryptoService.signTransaction(sender, transaction);
            this.transport.send([signedTx]);
            const newStoredTransactions = yield this.storageService.storeTransactions([signedTx]);
            if (newStoredTransactions.length) {
                yield this.notifyContextAboutNewTransactions(newStoredTransactions, yield this.storageService.getTransactions());
            }
        });
    }
    addOnNewTransactionsCallback(callback) {
        this.onNewTransactionsCallbacks.push(callback);
    }
    broadcastTransactions() {
        return __awaiter(this, void 0, void 0, function* () {
            const storedTransactions = yield this.storageService.getTransactions();
            this.transport.send(storedTransactions);
        });
    }
    // noinspection JSUnusedGlobalSymbols
    filterAndStoreStoredTransactions() {
        return __awaiter(this, void 0, void 0, function* () {
            const storedTransactions = yield this.storageService.getTransactions();
            const filteredTransactions = yield this.ignoreAndBlockFilterService.filterBlocked(storedTransactions);
            yield this.storageService.replaceAllTransactions(filteredTransactions);
        });
    }
    handleIncomingTransactions(incomingTransactions) {
        return __awaiter(this, void 0, void 0, function* () {
            const storedTransactions = yield this.storageService.getTransactions();
            const transactionsToStore = [];
            const hashesToBlock = [];
            incomingTransactions = yield this.ignoreAndBlockFilterService.filterBlocked(incomingTransactions);
            for (const incomingTx of incomingTransactions) {
                let txWasStored = false;
                for (const storedTx of storedTransactions) {
                    if (incomingTx.hash === storedTx.hash) {
                        yield this.updateStoredTransactionFromIncoming(storedTx, incomingTx);
                        txWasStored = true;
                        break;
                    }
                }
                if (!txWasStored) {
                    try {
                        this.validator.validateBase(storedTransactions, incomingTx);
                    }
                    catch (e) {
                        hashesToBlock.push(incomingTx.hash);
                        console.error('Incoming transaction is invalid by base rules', e, incomingTx);
                        continue;
                    }
                    try {
                        yield this.validator.validateSpecific(storedTransactions, incomingTx);
                        transactionsToStore.push(incomingTx);
                        storedTransactions.push(incomingTx);
                    }
                    catch (e) {
                        hashesToBlock.push(incomingTx.hash);
                        console.error('Incoming transaction is invalid by specific rules', e, incomingTx);
                    }
                }
            }
            if (transactionsToStore.length) {
                const newStoredTransactions = yield this.storageService.storeTransactions(transactionsToStore);
                if (newStoredTransactions.length) {
                    yield this.notifyContextAboutNewTransactions(newStoredTransactions, storedTransactions);
                }
            }
            if (hashesToBlock.length) {
                // Block invalid transactions. The list of blocked can be cleared manually later.
                yield this.ignoreAndBlockControlService.addTransactionHashesToBlock(hashesToBlock);
            }
        });
    }
    updateStoredTransactionFromIncoming(storedTx, incomingTx) {
        return __awaiter(this, void 0, void 0, function* () {
            const signatures = storedTx.signatures.concat(incomingTx.signatures);
            /* eslint-disable  @typescript-eslint/no-explicit-any */
            const publicKeys = {};
            let uniqueSignatures = [];
            for (const signature of signatures) {
                if (!publicKeys[signature.publicKey]) {
                    publicKeys[signature.publicKey] = true;
                    uniqueSignatures.push(signature);
                }
            }
            if (this.maxSignaturesNumber > 0) {
                uniqueSignatures = uniqueSignatures.slice(0, this.maxSignaturesNumber);
            }
            if (uniqueSignatures.length > storedTx.signatures.length) {
                yield this.storageService.storeTransactionSignatures(storedTx, uniqueSignatures);
            }
        });
    }
    notifyContextAboutNewTransactions(newTransactions, storedTransactions) {
        return __awaiter(this, void 0, void 0, function* () {
            newTransactions = yield this.ignoreAndBlockFilterService.filterIgnored(newTransactions);
            storedTransactions = yield this.ignoreAndBlockFilterService.filterIgnored(storedTransactions);
            for (const callback of this.onNewTransactionsCallbacks) {
                callback(newTransactions, storedTransactions);
            }
        });
    }
}
exports.TransactionService = TransactionService;
